import startCase from "lodash-es/startCase";
import cn from "classnames";
import { UserCard } from "@providers/profile/ProfileProvider.model";
import { ButtonWrap } from "../Account.styled";

export interface CreditCardInfoProps {
  card: UserCard | null;
  onEdit: (e: any) => void;
}

const CreditCardInfo = ({ card, onEdit }: CreditCardInfoProps) => (
  <div>
    {card && !card.error ? (
      <div className={cn("credit-card", card.brand)}>
        {startCase(card.brand)} ending in {card.last4} - Expires {card.exp_month}/{card.exp_year}
      </div>
    ) : (
      <div>No Card on File</div>
    )}
    <ButtonWrap>
      <button onClick={onEdit}>{card ? "Update Credit Card" : "Add One Now"}</button>
    </ButtonWrap>
  </div>
);

export default CreditCardInfo;
